import { useCallback, useState } from "react"

/**
 * Si la barra lateral está plegada, y que sobreviva a recargar.
 *
 * Es preferencia del operador, no estado de una pantalla: plegar el menú y encontrárselo
 * desplegado en la siguiente visita es de las cosas que más molestan de una herramienta
 * que se usa a diario.
 *
 * Va en `localStorage` y no en `sessionStorage` —al contrario que la sesión— porque
 * justamente lo que se quiere es que dure. No es una credencial: es una preferencia
 * visual, igual que el tema.
 *
 * `useState` con inicializador perezoso y no `useSyncExternalStore`: aquí la fuente de
 * la verdad es esta aplicación, que es la única que escribe la clave. `useTheme` sí usa
 * `useSyncExternalStore` para la preferencia del SISTEMA, que cambia desde fuera y hay
 * que escuchar.
 */
const CLAVE = "alpaca-nav-plegada"

export function useNavPlegada(): [boolean, () => void] {
  const [plegada, setPlegada] = useState(() => {
    try {
      return localStorage.getItem(CLAVE) === "1"
    } catch {
      // Un navegador con el almacenamiento bloqueado no debe impedir usar la consola.
      return false
    }
  })

  const alternar = useCallback(() => {
    setPlegada((actual) => {
      const siguiente = !actual
      try {
        localStorage.setItem(CLAVE, siguiente ? "1" : "0")
      } catch {
        // Se pierde la preferencia, no la funcionalidad.
      }
      return siguiente
    })
  }, [])

  return [plegada, alternar]
}
